import requestv2 from "~/utils/http-v2";

const samplesApi = {

    gets : async (type, params) => {
        const url = `v2/samples/${type}`;
        return await requestv2.get(url, {params});
    },
    update : async (params) => {
        const url = `v2/samples/${params.id}`;
        return await requestv2.patch(url, params);
    },
};

export default samplesApi;